import React from 'react';
import ChatLink from '~/components/organism/TipBanner/ChatLink';
import Link from '~/components/molecule/Link';
import { HELP_DESK_LINK } from '~/constants';

export const text = {
  tip: (
    <>
      Lees hoe je de koppeling moet instellen in onze{' '}
      <Link
        to={`${HELP_DESK_LINK}/articles/5487601-over-de-zapier-app`}
        openInNewTab
      >
        kennisbank
      </Link>
      . Kom je er niet uit? &nbsp;
      <ChatLink linkText="Start een chat met ons." />
    </>
  ),
};
